import _extends from "@babel/runtime-corejs3/helpers/extends";
import { createElementVNode as _$ce, className as _$cn, createVNode as _$cv, createUnknownComponentVNode as _$cc, extend as _$ex, EMPTY_OBJ as _$em } from 'intact-vue';
import { makeStyles } from './styles';
import { Tooltip } from '../tooltip';
import { getRestProps, addStyle } from '../utils';
export default function ($props, $blocks, $__proto__) {
  var _$cn2, _$cn3;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _this$get = this.get(),
    children = _this$get.children,
    className = _this$get.className,
    maxLines = _this$get.maxLines,
    disabled = _this$get.disabled,
    position = _this$get.position,
    theme = _this$get.theme,
    style = _this$get.style;
  var k = this.config.k;
  var _this$ellipsis = this.ellipsis,
    showTooltip = _this$ellipsis.showTooltip,
    ellipsisRef = _this$ellipsis.ellipsisRef;
  var tooltip = showTooltip.value && !disabled;
  var wrapper = _$ce(2, 'div', children, 0, _$cn((_$cn2 = {
    'c-ellipsis': true
  }, _$cn2[k + "-ellipsis-wrapper"] = true, _$cn2[className] = className && !tooltip, _$cn2)));
  return _$cv('div', _extends({}, getRestProps(this), {
    'className': _$cn((_$cn3 = {}, _$cn3[k + "-ellipsis"] = true, _$cn3[k + "-multiline"] = maxLines, _$cn3[makeStyles(k, maxLines)] = true, _$cn3)),
    'ref': ellipsisRef
  }), tooltip ? _$cc(Tooltip, {
    'position': position,
    'theme': theme,
    'className': _$cn(className),
    'children': wrapper,
    '$blocks': function ($blocks) {
      var _$blocks = {},
        __$blocks = _$ex({}, $blocks);
      return (_$blocks['content'] = function ($super) {
        return children;
      }, __$blocks['content'] = function ($super, data) {
        var block = $blocks['content'];
        var callBlock = function callBlock() {
          return _$blocks['content'].call($this, $super, data);
        };
        return block ? block.call($this, callBlock, data) : callBlock();
      }), __$blocks;
    }.call($this, _$em)
  }) : wrapper);
}
;